/**
 * Composer images as short labels. A plain text box can't show pictures, so an uploaded image's
 * long code (FoF Upload's [upl-image-preview …] BBCode, or Markdown ![alt](url)) is replaced in the
 * box by "[📷 Image 1]", with a strip of thumbnails underneath (each removable). Posting swaps the
 * labels back to the real code, so the published post shows the image where it was placed.
 */

const BBCODE = /\[upl-image(?:-preview)?\s+[^\]]*?url=([^\s\]]+)[^\]]*\]/g;
const MARKDOWN = /!\[([^\]]*)\]\((https?:\/\/[^\s)]+)\)/g;
const LABEL = /\[📷 Image (\d+)\]/g;
export const state = {
  images: {},
  next: 1
}; // number -> { code, url, thumb }

export function reset() {
  state.images = {};
  state.next = 1;
}
function thumbOf(code, url) {
  const t = /thumbnail_url=([^\s\]]+)/.exec(code);
  return t ? t[1] : url;
}

/** Replace long image code with labels; returns the shortened text and how much it shrank before `cursor` */
export function shorten(text, cursor) {
  if (cursor === void 0) {
    cursor = text.length;
  }
  let shift = 0;
  let out = text.replace(BBCODE, (m, url, offset) => {
    const n = state.next++;
    state.images[n] = {
      code: m,
      url,
      thumb: thumbOf(m, url)
    };
    const label = '[📷 Image ' + n + ']';
    if (offset < cursor) shift += m.length - label.length;
    return label;
  });
  const cursor2 = cursor - shift;
  let shift2 = 0;
  out = out.replace(MARKDOWN, (m, alt, url, offset) => {
    const n = state.next++;
    state.images[n] = {
      code: m,
      url,
      thumb: url
    };
    const label = '[📷 Image ' + n + ']';
    if (offset < cursor2) shift2 += m.length - label.length;
    return label;
  });
  return {
    text: out,
    shift: shift + shift2
  };
}

/** Labels back to the real code (unknown labels are left as written) */
export function expand(text) {
  return String(text || '').replace(LABEL, (m, n) => state.images[n] ? state.images[n].code : m);
}

/** The labels currently in the text, in order */
export function labelsIn(text) {
  const out = [];
  String(text || '').replace(LABEL, (m, n) => {
    if (state.images[n] && !out.includes(n)) out.push(n);
    return m;
  });
  return out;
}

/** Remove one image's label from the text */
export function removeLabel(text, n) {
  return String(text || '').replace(new RegExp('\\n?\\[📷 Image ' + n + '\\]\\n?', 'g'), '\n').replace(/^\n+/, '');
}